/* =========================================================
   OVERTOP — Price "FLAT X% OFF" Rewriter (Horizon v3)
   ---------------------------------------------------------
   v3 fixes:
   1. moneyToNumber() — old version preserved the dot from
      "Rs." prefix so "Rs.1,490.00" parsed as 0.149 instead
      of 1490, producing wrong percentages every time.
   2. Only target the FIRST <product-price> under MainContent
      (i.e. the main product price block) — so we don't end
      up reading prices from sticky bars / recommendations /
      recently viewed cards.
   ========================================================= */

(function () {

  function moneyToNumber(text) {
    if (!text) return null;
    var s = String(text).trim();

    // Strip leading currency prefix ("Rs.", "$", "PKR ", etc.)
    s = s.replace(/^[^0-9]+/, '');
    // Strip trailing non-digit suffix (e.g. " PKR")
    s = s.replace(/[^0-9.,]+$/, '');
    // Strip thousand separators (commas in en-PK / en-US)
    s = s.replace(/,/g, '');

    if (!s) return null;
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function isProductTemplate() {
    var main = document.getElementById('MainContent');
    var t = main && main.dataset ? main.dataset.template : '';
    return typeof t === 'string' && t.indexOf('product') !== -1;
  }

  function getMainProductPrice() {
    var main = document.getElementById('MainContent');
    if (!main) return null;
    // The first <product-price> inside MainContent is the main product's
    // price block. Auxiliary slots (sticky bar, recs, recently viewed)
    // appear later in DOM order.
    return main.querySelector('product-price');
  }

  function ensureBadgeIn(productPrice) {
    if (!productPrice) return;

    var sale = productPrice.querySelector('.price__sale');
    if (!sale) return;

    if (sale.classList.contains('price__hidden')) {
      var stale = productPrice.querySelector('.ot-flat-badge');
      if (stale) stale.remove();
      return;
    }

    var compareEl = sale.querySelector('.compare-at-price, .price-item--regular');
    var saleEl    = sale.querySelector('.price-item--sale, .price');
    if (!compareEl || !saleEl) return;

    var compareN = moneyToNumber(compareEl.textContent);
    var saleN    = moneyToNumber(saleEl.textContent);
    if (!compareN || !saleN || compareN <= saleN) return;

    var pct = Math.round(((compareN - saleN) / compareN) * 100);
    if (pct <= 0) return;

    var newText = 'FLAT ' + pct + '% OFF';

    var existing = productPrice.querySelector('.ot-flat-badge');
    if (existing) {
      if (existing.textContent === newText) return;
      existing.textContent = newText;
      return;
    }

    var badge = document.createElement('div');
    badge.className = 'ot-flat-badge';
    badge.textContent = newText;
    productPrice.insertBefore(badge, productPrice.firstChild);
  }

  function applyAll() {
    if (!isProductTemplate()) return;
    var pp = getMainProductPrice();
    if (pp) ensureBadgeIn(pp);
  }

  function boot() {
    applyAll();

    document.addEventListener('variant:update', function () {
      setTimeout(applyAll, 80);
      setTimeout(applyAll, 280);
    });

    // Also re-apply after late hydration (some Horizon sections render async)
    setTimeout(applyAll, 600);
    setTimeout(applyAll, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
